import { countPerformed } from "./performedRules";

export const AUTO_FINALIZE_HOURS = 12;

export function finalizationDeadline(finishedAt) {
  const value = new Date(finishedAt);
  if (Number.isNaN(value.getTime())) throw new TypeError("finishedAt must be valid");
  return new Date(value.getTime() + AUTO_FINALIZE_HOURS * 60 * 60 * 1000);
}

export function finalizeIfDue(record, now = new Date()) {
  const status = record?.status || record?.document?.status;
  const finishedAt = record?.finishedAt || record?.document?.finishedAt;
  if (status !== "FINISHED" || !finishedAt) return { due: false, action: null };
  const deadline = finalizationDeadline(finishedAt);
  const clock = new Date(now);
  if (Number.isNaN(clock.getTime())) throw new TypeError("now must be valid");
  if (clock < deadline) {
    return { due: false, action: null, deadline: deadline.toISOString() };
  }
  const performedCount = countPerformed(record);
  return {
    due: true,
    action: performedCount > 0 ? "SAVE" : "DISCARD_AUTO_EMPTY",
    deadline: deadline.toISOString(),
    savedAt: deadline.toISOString(),
    finalizedBy: "AUTO_12H",
  };
}
